<template>
  <div class="text-sm text-yellow-500">
    <slot />
  </div>
</template>
